import "./loading.css";

const LoadingProducts = () => {

  return (
    
    <div className="loadingPro rounded-2xl overflow-hidden w-full bg-slate-50 h-[170px]">
      <div className=""></div>
      <div></div>
    </div>
  );
};

export default LoadingProducts;
